module.exports = __webpack_public_path__ + "static/media/img7.d3e4ace4.jpg";